import type { Technique } from './types';

export type TechniquePhase = 'mvp' | 'post-mvp';

/**
 * 手法 id と表示名（card-schema.md §3.5）。schema の `$defs.technique` と同じ並び。
 * 手法を足すときは schema・card-schema.md・この表を同じ変更で直す。
 */
export const TECHNIQUES: readonly { id: Technique; label: string; phase: TechniquePhase }[] = [
  { id: 'single-loop', label: '1 重ループ', phase: 'mvp' },
  { id: 'double-loop-search', label: '2 重ループの全探索', phase: 'mvp' },
  { id: 'triple-loop-search', label: '3 重ループの全探索', phase: 'mvp' },
  { id: 'digit-while', label: '桁を割る while', phase: 'mvp' },
  { id: 'array-count', label: '配列で数える', phase: 'mvp' },
  { id: 'dict', label: '辞書', phase: 'mvp' },
  { id: 'set', label: 'Set', phase: 'mvp' },
  { id: 'stack', label: 'スタック', phase: 'mvp' },
  { id: 'queue', label: 'キュー', phase: 'mvp' },
  { id: 'cumulative-sum', label: '累積和', phase: 'mvp' },
  { id: 'sort-and-binary-search', label: 'ソート + 二分探索', phase: 'mvp' },
  { id: 'sort-and-greedy', label: 'ソート + 貪欲', phase: 'post-mvp' },
  { id: 'two-pointers', label: '尺取り法', phase: 'post-mvp' },
  { id: 'bit-full-search', label: 'bit 全探索', phase: 'post-mvp' },
  { id: 'bfs', label: 'BFS', phase: 'post-mvp' },
  { id: 'dfs', label: 'DFS', phase: 'post-mvp' },
  { id: 'dp', label: 'DP', phase: 'post-mvp' },
];

const BY_ID = new Map(TECHNIQUES.map((t) => [t.id, t]));

/** MVP 後の手法を使ってよい最小の stage（card-schema.md §3.5）。 */
export const POST_MVP_MIN_STAGE = 5;

export function techniqueLabel(id: Technique): string {
  return BY_ID.get(id)?.label ?? id;
}

/** reduce の選択肢の表示名。note があれば括弧で添える（card-schema.md §3.5）。 */
export function reduceOptionLabel(opt: { technique: Technique; note?: string }): string {
  const label = techniqueLabel(opt.technique);
  return opt.note ? `${label}（${opt.note}）` : label;
}

export function isPostMvpTechnique(id: Technique): boolean {
  return BY_ID.get(id)?.phase === 'post-mvp';
}
